/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Fast_TitleInputs */

const en_wc_why_fast_title = /** @type {(inputs: Wc_Why_Fast_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seriously fast`)
};

/**
* | output |
* | --- |
* | "Seriously fast" |
*
* @param {Wc_Why_Fast_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_fast_title = /** @type {((inputs?: Wc_Why_Fast_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Fast_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_fast_title(inputs)
});
export { wc_why_fast_title as "wc.why.fast.title" }